const ARITHMETIC_EXPRESSION = /^[\d\s+\-*/().]+$/;

export const isArithmeticExpression = (expression: string) => ARITHMETIC_EXPRESSION.test(expression);

export function calculate(expression: string): number | undefined {
	const tokens = expression.match(/\d+(?:\.\d+)?|[+\-*/()]/g);
	if (!tokens) return undefined;
	let position = 0;

	const parseSum = (): number => {
		let result = parseProduct();
		while (tokens[position] === '+' || tokens[position] === '-') {
			const operator = tokens[position++];
			const operand = parseProduct();
			result = operator === '+' ? result + operand : result - operand;
		}
		return result;
	};

	const parseProduct = (): number => {
		let result = parseOperand();
		while (tokens[position] === '*' || tokens[position] === '/') {
			const operator = tokens[position++];
			const operand = parseOperand();
			result = operator === '*' ? result * operand : Math.floor(result / operand);
		}
		return result;
	};

	const parseOperand = (): number => {
		const token = tokens[position++];
		if (token === '-') return -parseOperand();
		if (token === '(') {
			const result = parseSum();
			position++;
			return result;
		}
		return Number(token);
	};

	const result = parseSum();
	return position === tokens.length && Number.isFinite(result) ? result : undefined;
}
